import React, { useEffect, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCar, faTruck, faTachometerAlt, faBiking, faReply, faWalking } from '@fortawesome/free-solid-svg-icons';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Cookies from 'js-cookie';
import { NavLink } from 'react-router-dom';
import MaterialTable from 'material-table';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { TablePagination, CircularProgress } from '@material-ui/core';
import API_PATH from "../../constants/config.json";
import { getPrivileges } from '../../functions/Auth';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: '0px',
    bottom: '5px',
    height: '77vh',
    '@media only screen and (max-height: 820px)': {
      height: '70vh'
    },
    '@media only screen and (max-width: 3500px)': {
      width: '482px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '882px',
    },
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
  },
  searchMainBlock: {
    padding: '10px',
    position: 'fixed',        
    float: 'left',
    background: '#fff',
    border: '1px solid #24618E',
    //borderRadius: '5px',
    borderRadius: '0px 5px 5px 0px',
    borderLeft: '0px',
    bottom: '5px',
    left: '-2px',
    zIndex: '22',
    height: '86.8vh', 
    width: '505px',
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
    '@media only screen and (min-width: 3501px)': {
      '& .MuiSelect-select':{
        fontSize:'22pt',
      },
      '& .MuiTypography-caption':{
        fontSize:'22pt',
      }
    }, 
    // marginBottom: '60px',
    '& h4': {      
      margin: '0',
      color: '#333',
      marginBottom: '5px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '25pt',
      }, 
    },
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: '0',
    },
    '& .MuiBox-root': {      
      height: '71vh',
      '@media only screen and (max-height: 820px)': {
        height: '62vh'
      }, 
    },
    '& th.MuiTableCell-root.MuiTableCell-head': {
      display: 'none',
    },
    '& .MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded': {
      position: 'unset !important',
    },
    '& .MuiToolbar-regular': {
      minHeight: '0px',
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  }, tabblock: {
    border: '1px solid #24618E',
    paddingTop: '10px',
    marginBottom: '0px',
    borderRadius: '0px 5px 5px 5px',
    width: '100%',
    float: 'left',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    }
  },
  closeIcon: {
    textAlign: 'right',
    margin: '0',
    position: 'absolute',
    top: '10px',
    cursor: 'pointer',
    color: '#24618E',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
      right: '10px',
      width: '40px'
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
      right: '15px',
      width: '60px',
    },
    '&:hover': {
      color: '#CC0000',
    }
  },
  stationDeatilsBlock: {
    cursor: 'pointer',
    border: '1px solid #00A75D',
    borderRadius: '5px',
    padding: '10px',
    marginBottom: '10px',
    width: '99%',
    float: 'left',
    '& ul': {
      padding: '0',
      margin: '0',
    },
    '& li': {
      display: 'inline-block',
      textAlign: 'center',
      padding: '0 20px',
      '& svg': {
        verticalAlign: 'middle',
        color: '#24618E',
      }
    },
    '& p': {
      marginTop: 0,
      marginBottom: '5px',
      color: '#24618E',
      '& .checkBoxes': {
        padding: '0',
        verticalAlign: 'middle',
        paddingRight: '5px',
        position: 'relative',
        top: '-2px',
      }
    },
  },
  expoSelected: {
    background: '#fff',
    color: '#333',
    border: '1px solid #333',
    marginTop: '5px',
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
      background: '#fff',
    }
  },
  myCheckBox: {
    padding: '0',
    verticalAlign: 'middle',
    paddingRight: '5px',
    position: 'relative',
    top: '-2px',
    paddingLeft: '11px',
  }, tabRoot: {

  },
  headerDiv: {
    width: '100%',
    float: 'left',
    '& .MuiSvgIcon-root': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt'
      },
    },
    '& .headerDiv-left': {
      width: '60%',
      float: 'left',
    },
    '& .headerDiv-right': {
      width: '40%',
      float: 'right', tabRoot: {

      },
      textAlign: 'right',
    }
  },
  swipe: {
    '& div:first-child': {
      // overflow: 'hidden !important',
    },
    '& .MuiToolbar-root.MuiToolbar-regular': {
      '@media only screen and (max-width: 3500px)': {
        height: '50px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '60px',
      },
    },
    '& .MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded div:nth-child(2)': {
      marginTop: '-45px',
      height: '57vh',
      '@media only screen and (max-height: 820px)': {
        height: '45vh'
      },
    }
  },
  loader: {
    '& .MuiCircularProgress-root': {
      color: '#24618E !important',
      marginLeft: '50% !important',
      marginTop: '50% !important'
    }
  },
  panelDivLeft: {
    float: 'left',
    marginLeft: '-10px',
    marginTop: '-10px',
    '@media only screen and (max-width: 3500px)': {
      width: '7%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '5%',
    },
    '& .MuiSvgIcon-root': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt'
      },
    }

  },
  panelDivRight: {
    float: 'right',
    height: 'auto !important',
    marginTop: '0 !important',
    '@media only screen and (max-width: 3500px)': {
      width: '93%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '95%',
    },
  },
  searchDiv: {

  },
  totalResults: {
    margin: '0 0 3px'
  }

}));
//End Css code ...

//Start SearchResults component code ...
const SearchResults = props => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [midblockData, setmidBlockData] = React.useState([]);
  const [intersectionData, setIntersectionData] = React.useState([]);
  const [pageNoMidblock, setPageNoMidblock] = React.useState(0);
  const [pageSizeMidblock, setPageSizeMidblock] = React.useState(25);
  const [dataFromMidblock, setDataFromMidblock] = React.useState(1);
  const [dataToMidblock, setDataToMidblock] = React.useState(pageSizeMidblock);

  const [pageNoIntersection, setPageNoIntersection] = React.useState(0);
  const [pageSizeIntersection, setPageSizeIntersection] = React.useState(25);
  const [dataFromIntersection, setDataFromIntersection] = React.useState(1);
  const [dataToIntersection, setDataToIntersection] = React.useState(pageSizeIntersection);

  const [allIntersectionCheck, setAllIntersectionCheck] = React.useState(false);
  const [allMidblockCheck, setAllMidblockCheck] = React.useState(false);

  const [loader, setLoader] = React.useState(false);
  const prevDataRef = React.useRef();
  const prevSearhcRef = React.useRef();
  const prevData = prevDataRef.current;
  const prevSearch = prevSearhcRef.current;

  useEffect(
    () => {
      if (props.selectedStationType == 1) {
        setValue(1);
      } else if (props.selectedStationType == 2) {
        setValue(0);
      }
      prevDataRef.current = props.resultData;
      prevSearhcRef.current = props.searchParam;
      if (props.resultData !== prevData) {
        getYearsData(props.resultData);
      }
    }, [props.resultData, props.selectedStationType]
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const onChangePageMidblock = page => {
    let startValue = pageSizeMidblock * page + 1;
    let endValue = pageSizeMidblock * (page + 1);

    if (startValue == midblockData.length) {
      setPageNoMidblock(page);
      setDataFromMidblock(startValue);
      setDataToMidblock(midblockData.length);
    } else if (endValue >= midblockData.length) {
      setPageNoIntersection(page);
      setDataFromMidblock(startValue);
      setDataToMidblock(midblockData.length);
    } else {
      setPageNoMidblock(page);
      setDataFromMidblock(startValue);
      setDataToMidblock(pageSizeMidblock * (page + 1));
    }
  };

  const onChangeRowsPerPageMidblock = pageSize => {
    setPageSizeMidblock(pageSize);
    if (pageSize >= midblockData.length) {
      setDataToMidblock(midblockData.length);
    } else {
      setDataToMidblock(pageSize * (pageNoMidblock + 1));

    }

  }

  const onChangePageIntersection = page => {
    let startValue = pageSizeIntersection * page + 1;
    let endValue = pageSizeIntersection * (page + 1);
    if (startValue == intersectionData.length) {
      setPageNoIntersection(page);
      setDataFromIntersection(startValue);
      setDataToIntersection(intersectionData.length);
    } else if (endValue >= intersectionData.length) {
      setPageNoIntersection(page);
      setDataFromIntersection(startValue);
      setDataToIntersection(intersectionData.length);
    } else {
      setPageNoIntersection(page);
      setDataFromIntersection(startValue);
      setDataToIntersection(pageSizeIntersection * (page + 1));
    }
  };

  const onChangeRowsPerPageIntersection = pageSize => {
    setPageSizeIntersection(pageSize);
    if (pageSize >= intersectionData.length) {
      setDataToIntersection(intersectionData.length);
    } else {
      setDataToIntersection(pageSize * (pageNoIntersection + 1));

    }
  }
  const selectAllIntersection = (e) => {
    setAllIntersectionCheck((prev) => !prev);
    let intArr = intersectionData;
    props.allStations(e, 'Intersection', intArr);
    setIntersectionData(intArr.map(item => ({ ...item, checked: e.target.checked })));
  }

  const selectAllMidblock = (e) => {
    let intArr = midblockData;
    setAllMidblockCheck((prev) => !prev);
    props.allStations(e, 'Midblock', intArr);
    setmidBlockData(intArr.map(item => ({ ...item, checked: e.target.checked })));
  }

  const selectOneIntersection = async (e, station_type, client_Station_Id, Station_location) => {
    let intArr = intersectionData;
    setIntersectionData(intArr.map(item => (item.station_id == e.target.value ? { ...item, checked: e.target.checked } : item)));
    if (e.target.checked == true) {
      props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
    }
    else {
      setAllIntersectionCheck(false);
      props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
    }
  }

  const selectOneMidblock = async (e, station_type, client_Station_Id, Station_location) => {
    let intArr = midblockData;
    setmidBlockData(intArr.map(item => (item.station_id == e.target.value ? { ...item, checked: e.target.checked } : item)));
    if (e.target.checked == true) {
      props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
    }
    else {
      setAllMidblockCheck(false);
      props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
    }
  }

  //This method is use for API call to get years Data .... Start
  const getYearsData = async (data) => {
    setLoader(true);
    let yearData = data;
    let body = data.map((value) => {
      return {
        "station_id": value.station_id,
        "station_type": value.station_type == 1 ? "Midblock" : "Intersection"
      }
    })
    try {
      await axios({
        method: 'post',
        url: API_URL + API_PATH.getStationlistwithyear,
        data: body
      })
        .then(async function (response) {
          if (response && response.data.data) {
            let dataTemp = response.data.data;
            yearData.map((item, index) => item.station_id == dataTemp[index].station_id ? (item.class = dataTemp[index].class, item.speed = dataTemp[index].speed, item.volume = dataTemp[index].volume, item.bicycle = dataTemp[index].bicycle, item.pedestrian = dataTemp[index].pedestrian, item.volume = dataTemp[index].volume, item.turning = dataTemp[index].turning) : item);
          }
          setLoader(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoader(false);
        })
    } catch (error) {
      console.error(error);
      setLoader(false);
    }

    let tempMidblockArr = [];
    let tempIntersectionArr = [];
    yearData && yearData.filter((value, index) => {
      if (value.station_type == 1) {
        tempMidblockArr.push(value);
      } else {
        tempIntersectionArr.push(value);
      }
    });
    if (tempIntersectionArr.length == 0) setValue(1);
    if (pageSizeIntersection >= tempIntersectionArr.length) {
      setDataToIntersection(tempIntersectionArr.length);
    } else {
      setDataToIntersection(pageSizeIntersection)
    }
    if (pageSizeMidblock >= tempMidblockArr.length) {
      setDataToMidblock(tempMidblockArr.length);
    } else {
      setDataToMidblock(pageSizeMidblock)
    }

    setmidBlockData(tempMidblockArr);
    setIntersectionData(tempIntersectionArr);
  }
  //This method is use for API call to get years Data .... End

  return (
    <React.Fragment>
      <div className={classes.searchMainBlock} style={props.showExternalLayers ? {left: props.sidebarWidth} : {left: '-2px'}}
      >
        <h4 style={{ marginRight: '10px' }}>Search Results {props.searchParam ? 'for ' + props.searchParam : null}</h4>
        <p onClick={props.passMidValue} className={classes.closeIcon}>
          <FontAwesomeIcon icon={faTimes} className={classes.btnIcon} title="Close" />
        </p>
        <hr style={{ marginTop: '0px', borderBottom: '1px solid #00A75D', borderTop: '0', }} />
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Intersection" {...a11yProps(0)} id="interSection_Tab" data-testid="intersectiontab" />
              <Tab label="Midblock" {...a11yProps(1)} id="midblock_tab" data-testid="midblocktab" />

              {/* <Tab label="Add New Users" {...a11yProps(2)} /> */}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value} className={classes.swipe}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock}>
              {
                loader == false ? intersectionData.length > 0 ?
                  <div className={classes.headerDiv}>
                    <div className='headerDiv-left'>
                      <p style={{ margin: '0' }}>Showing {dataFromIntersection} - {dataToIntersection} of {intersectionData.length} results</p>
                      <p style={{ margin: '0', marginTop: '5px' }}><Checkbox
                        color="primary" className={classes.myCheckBox}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        onChange={(e) => selectAllIntersection(e)}
                        disabled={getPrivileges().length > 0 ? false : true}
                        checked={allIntersectionCheck}
                      />Select All</p>
                    </div>
                    <div className='headerDiv-right'>
                      {
                        getPrivileges().length > 0 ?
                          props.setStation && props.setStation.length > 0 ?
                            <Button variant="outlined" id="export_selected" className={classes.expoSelected} onClick={props.checkExportValue}>
                              Export Selected</Button> : <Button variant="outlined" id="export_selected" className={classes.expoSelected} onClick={props.checkExportValue} disabled>
                              Export Selected</Button>
                          :
                          null
                      }

                    </div>
                  </div>
                  : <div className={classes.headerDiv} >
                    <div className='headerDiv-left' style={{ width: '100%' }}>
                      <p style={{ margin: '0' }}>No results exist for {props.searchParam}</p>
                    </div>

                  </div> : null
              }
              {
                loader == false ?
                  <MaterialTable
                    icons={tableIcons}
                    title=""
                    
                    columns={[
                      {
                        render: rowData => <div className={classes.stationDeatilsBlock}  style={rowData.client_station_id == props.selectedStation ? { background: '#F2F2F2' } : null}

                        >
                          <div className={classes.searchDiv}>
                            <div className={classes.panelDivLeft}><Checkbox
                              value={rowData.station_id}
                              checked={rowData.checked}
                              color="primary" className='checkBoxes'
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                              onChange={(e) => selectOneIntersection(e, rowData.station_type, rowData.client_station_id, rowData.location)}
                              disabled={getPrivileges().length > 0 ? false : true}
                            /></div>
                            <div className={classes.panelDivRight} onClick={() => props.highlightStation(rowData.latitude, rowData.longitude, rowData.client_station_id, rowData.station_type)}>
                              <NavLink to='#' style={{ textDecoration: 'none', color: '#24618E' }} onClick={() => props.getStationDetail(rowData.station_id)}>{rowData.client_station_id} - {rowData.location}</NavLink>

                              <ul>
                                {rowData.turning == '' && rowData.pedestrian == '' && rowData.bicycle == '' ?
                                  <li style={{ padding: '0px' }}><span>{'No data has been imported for this station'}</span> </li> :
                                  <>
                                    {rowData.turning == '' ? null : <li><FontAwesomeIcon icon={faReply} className={classes.btnIcon} /> <br /> <span>{rowData.turning}</span> </li>}
                                    {rowData.pedestrian == '' ? null : <li><FontAwesomeIcon icon={faWalking} className={classes.btnIcon} /> <br /> <span>{rowData.pedestrian}</span> </li>}
                                    {rowData.bicycle == '' ? null : <li><FontAwesomeIcon icon={faBiking} className={classes.btnIcon} /> <br /> <span>{rowData.bicycle}</span> </li>}
                                  </>

                                }

                              </ul>
                            </div>
                          </div>
                        </div>,
                        headerStyle: {
                          width: '10%',
                        }
                      }
                    ]}

                    data={intersectionData ? intersectionData : []}
                    totalCount={intersectionData.length}
                    options={{
                      filtering: false,
                      sorting: false,
                      title: false,
                      paging: intersectionData.length > 0 ? true : false,
                      pageSize: pageSizeIntersection,
                      pageSizeOptions: [5, 10, 25],
                      search: false,
                      emptyRowsWhenPaging: false,
                    }}
                    onChangePage={onChangePageIntersection}
                    onChangeRowsPerPage={onChangeRowsPerPageIntersection}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <></>
                        ),
                      },
                    }}
                  />
                  :
                  <div className={classes.loader}>
                    <CircularProgress />

                  </div>
              }


            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock}>
              {
                loader == false ? midblockData.length > 0 ?
                  <div className={classes.headerDiv}>
                    <div className='headerDiv-left'>
                      <p style={{ margin: '0' }}>Showing {dataFromMidblock} - {dataToMidblock} of {midblockData.length} results</p>
                      <p style={{ margin: '0', marginTop: '5px' }}><Checkbox
                        color="primary" className={classes.myCheckBox}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                        onChange={(e) => selectAllMidblock(e)}
                        disabled={getPrivileges().length > 0 ? false : true}
                        checked={allMidblockCheck}
                      />Select All</p>
                    </div>
                    <div className='headerDiv-right'>
                      {getPrivileges().length > 0 ?
                        props.setStation && props.setStation.length > 0 ?
                          <Button variant="outlined" id="export_selected" className={classes.expoSelected} onClick={props.checkExportValue}>
                            Export Selected</Button> : <Button variant="outlined" id="export_selected" className={classes.expoSelected} onClick={props.checkExportValue} disabled>
                            Export Selected</Button>
                        : null
                      }
                    </div>
                  </div>
                  : <div className={classes.headerDiv} >
                    <div className='headerDiv-left' style={{ width: '100%' }}>
                      <p style={{ margin: '0' }}>No results exist for {props.searchParam}</p>
                    </div>

                  </div> : null
              }

              {
                loader == false ? <MaterialTable
                  icons={tableIcons}
                  title=""
                  columns={[
                    {
                      render: rowData => <div className={classes.stationDeatilsBlock} style={rowData.client_station_id == props.selectedStation ? { background: '#F2F2F2' } : null}
                      >
                        <div className={classes.searchDiv}>
                          <div className={classes.panelDivLeft}><Checkbox
                            value={rowData.station_id}
                            checked={rowData.checked}
                            color="primary" className='checkBoxes'
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                            onChange={(e) => selectOneMidblock(e, rowData.station_type, rowData.client_station_id, rowData.location)}
                            disabled={getPrivileges().length > 0 ? false : true}
                          />
                          </div></div>
                        <div className={classes.panelDivRight} onClick={() => props.highlightStation(rowData.latitude, rowData.longitude, rowData.client_station_id, rowData.station_type)}><NavLink to='#' style={{ textDecoration: 'none', color: '#24618E' }} onClick={() => props.getStationDetail(rowData.station_id)}>{rowData.client_station_id} - {rowData.location}</NavLink>
                          <ul>
                            {rowData.volume == '' && rowData.class == '' && rowData.speed == '' ?
                              <li style={{ padding: '0px' }}><span>{'No data has been imported for this station'}</span> </li> :
                              <>
                                {rowData.volume == '' ? null : <li><FontAwesomeIcon icon={faCar} className={classes.btnIcon} /> <br /> <span>{rowData.volume}</span> </li>
                                }
                                {rowData.class == '' ? null : <li><FontAwesomeIcon icon={faTruck} className={classes.btnIcon} /> <br /> <span>{rowData.class}</span> </li>}
                                {rowData.speed == '' ? null : <li><FontAwesomeIcon icon={faTachometerAlt} className={classes.btnIcon} /> <br /> <span>{rowData.speed}</span> </li>}
                              </>
                            }

                          </ul>
                        </div>
                      </div>,
                      headerStyle: {
                        width: '10%',
                      }
                    }
                  ]}

                  data={midblockData ? midblockData : []}
                  totalCount={midblockData.length}
                  options={{
                    filtering: false,
                    sorting: false,
                    title: false,
                    paging: midblockData.length > 0 ? true : false,
                    pageSize: pageSizeMidblock,
                    pageSizeOptions: [5, 10, 25],
                    search: false,
                    showSelectAllCheckbox: true,
                    emptyRowsWhenPaging: false
                  }}
                  onChangePage={onChangePageMidblock}
                  onChangeRowsPerPage={onChangeRowsPerPageMidblock}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <></>
                      ),
                    },
                  }}

                />
                  :
                  <div className={classes.loader}>
                    <CircularProgress />

                  </div>
              }

            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchResults;
//End SearchResults component code ...
